<div id="wallpaperlines" v-show="show">
  <div v-for="n in getLines" class="lines" :style="getLeft(getLines, n)"></div>
</div>
